import { render, staticRenderFns } from "./budget-add-or-update.vue?vue&type=template&id=058ce301&scoped=true&"
import script from "./budget-add-or-update.vue?vue&type=script&lang=js&"
export * from "./budget-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./budget-add-or-update.vue?vue&type=style&index=0&id=058ce301&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ce301",
  null
  
)

export default component.exports